export default __webpack_public_path__ + "static/media/startscreentitle.5502f2ab.png";